export type FeatureFlags = {
    _testPurpose: boolean
    hasSDDRepayments: boolean
    hasUserLimits: boolean
    hasRequirementsPortalLink: boolean
}

export const parseBooleanEnvVar = (value: string | undefined): boolean => value === 'true'

export const parseListEnvVar = (value: string | undefined): string[] => value?.split(',').filter(Boolean) ?? []

export const getFeatureFlags = (): FeatureFlags => ({
    _testPurpose: parseBooleanEnvVar(process.env._TEST_PURPOSE),
    hasSDDRepayments: parseBooleanEnvVar(process.env.NEXT_PUBLIC_HAS_SDD_REPAYMENTS),
    hasUserLimits: parseBooleanEnvVar(process.env.NEXT_PUBLIC_HAS_BENEFICIARY_LIMITS),
    hasRequirementsPortalLink: parseBooleanEnvVar(process.env.NEXT_PUBLIC_HAS_REQUIREMENTS_PORTAL_LINK)
})
